import { render, staticRenderFns } from "./TemplateOverviewComponent.vue?vue&type=template&id=345b5d49&scoped=true&"
import script from "./TemplateOverviewComponent.vue?vue&type=script&lang=js&"
export * from "./TemplateOverviewComponent.vue?vue&type=script&lang=js&"
import style0 from "./TemplateOverviewComponent.vue?vue&type=style&index=0&id=345b5d49&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "345b5d49",
  null
  
)

export default component.exports